(() => {
  const popup = document.querySelector("[data-saza-exit-offer]");
  if (!popup) return;

  const isProductPage = window.location.pathname.startsWith("/products/");
  const isCartOrCheckout =
    window.location.pathname.startsWith("/cart") ||
    window.location.pathname.startsWith("/checkouts");

  const storageKey = "sazaExitOfferSeenV3";
  const isTestMode = new URLSearchParams(window.location.search).has("saza_offer_test");
  const sevenDays = 7 * 24 * 60 * 60 * 1000;
  const isMobile = window.matchMedia("(max-width: 699px)").matches;

  let opened = false;
  let addedToCart = false;
  let destinationUrl = null;

  if ((!isProductPage && !isTestMode) || isCartOrCheckout) return;

  const seenAt = Number(localStorage.getItem(storageKey));
  const seenRecently = seenAt && Date.now() - seenAt < sevenDays;

  if (seenRecently && !isTestMode) return;

  const continueLink = popup.querySelector(".saza-exit-offer__shop");

  const openOffer = (url = null) => {
    if (opened || addedToCart) return;

    opened = true;
    destinationUrl = url;
    popup.hidden = false;
    document.body.style.overflow = "hidden";

    if (continueLink) {
      if (destinationUrl) {
        continueLink.href = destinationUrl;
        continueLink.textContent = "Continue to your destination";
      } else {
        continueLink.href = "/collections/all";
        continueLink.textContent = "Continue shopping";
      }
    }
  };

  const closeOffer = () => {
    popup.hidden = true;
    document.body.style.overflow = "";
    localStorage.setItem(storageKey, String(Date.now()));
  };

  document.addEventListener("submit", (event) => {
    if (event.target.matches('form[action*="/cart/add"]')) {
      addedToCart = true;
    }
  });

  popup.querySelectorAll("[data-saza-offer-close]").forEach((element) => {
    element.addEventListener("click", closeOffer);
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && !popup.hidden) closeOffer();
  });

  if (isTestMode) {
    setTimeout(openOffer, 900);
    return;
  }

  if (isMobile) return;

  let exitIntentReady = false;
  setTimeout(() => { exitIntentReady = true; }, 10000);
  document.addEventListener("mouseleave", (event) => {
    if (exitIntentReady && event.clientY <= 0) openOffer();
  }, { once: true });
})();
